import { useContext } from 'react';
import useCURD_Queries from '../queryGenerals/useCURD_Queries'
import { GlobalContext } from '../../../App';
import { useAddData, useGetDataByName, useUpdateData, updateOrAddItem } from '../../dataLocal/indexedDBHooks';
import { v4 as uuidv4 } from 'uuid';

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('שגיאה בקבלת כתובת IP:', error);
    return null;
  }
};

const useResidencyQueries = () => {
  const { setDataResidencies, userId, db } = useContext(GlobalContext)
  const { AllDataEntities, addOrUpdateDataEntity2, removeEntity } = useCURD_Queries()

  const addData = useAddData(db, 'myStore');
  const updateData = useUpdateData(db, 'myStore');
  const getDataByName = useGetDataByName(db, 'myStore');

  const AllDataResidencies = async () => {
    console.log(123);
    
    try {
      let query = `api/residencies/getResidencies`
      let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`
      let nameEntity = 'dataResidencies'

      const data = await AllDataEntities(url); // המתנה לתוצאה

      setDataResidencies(data?.resData || [])
      if (db) {
        getDataByName(nameEntity)
          .then((existingData) => {
            if (existingData.length > 0) {
              // אם הנתונים קיימים, עדכן אותם
              updateData({ id: 15, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Updated Data:', data);
                })
                .catch((error) => console.error('Error updating data:', error));
            } else {
              // אם הנתונים לא קיימים, הוסף אותם
              addData({ id: 15, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  console.log('Added Data:', data);
                })
                .catch((error) => console.error('Error adding data:', error));
            }
          })
          .catch((error) => console.error('Error getting data by name:', error));
      }

    } catch (error) {
      console.error("שגיאה בטעינת נתונים: ", error);
    }
  }

  const addOrUpdateDataResidency = async (data, unicId) => {
    let create = `api/residencies/addResidency`
    let update = `api/residencies/updateResidency`
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${(data?.id) ? update : create}`
    
    let ip = ''
    // דוגמה לשימוש בפונקציה
    await getUserIP().then(myIp => {
      ip = myIp
    });

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'residencies',
      actionType: (data?.unicId) ? 'UPDATE' : 'INSERT',
      oldValue: null,
      newValue: data,
    };

    
    data = data?.map(d => {
      const unicId = uuidv4();
      return {
      ...d,
      unicId: unicId
    }
  })

    // if (!data?.unicId) {
    //   data = [
    //     ...data,
    //   ]

    // }

    try {
      let res = await addOrUpdateDataEntity2(data, payload, url);
      if (res) {
        await updateOrAddItem(db, 'myStore', data, 'dataBlocks', 2 );
        console.log('התוצאה הצליחה...')
        return res
      } else {
        return false
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
      return false
    }
  }

  const removeResidency = (id) => {
    let query = `api/residencies/removeResidency`
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`
    removeEntity(id, url)
  }

  return {
    AllDataResidencies,
    addOrUpdateDataResidency,
    removeResidency
  }
};

export default useResidencyQueries;
